module.exports = __webpack_public_path__ + "img/license-expired.2f1adf5.png";